// 设备相关API接口
import request from '@/utils/request'
// 向外按需导出一个API函数
/**
 * 查询用户设备列表
 * @param params
 * @param data
 * @returns {*}
 */
export function upList(params,data) {
    // console.log('获取用户设备列表',params,data)
    return request({
        url: '/project/user/project',
        method: 'post',
        data,
        params
    })
}

/**
 * 根据项目的pid查询指定设备的相关信息
 * @param pid
 * @returns {*}
 */
export function deviceInfo(params) {
    return request({
        url: '/assign',
        method: 'get',
        params
    })
}

/**
 *
 * @param params
 * @param pid
 * @returns {*}
 */
export function deviceGrid(params,pid) {
    return request({
        url: '/assign/'+pid+'/grid',
        method: 'get',
        params
    })
}
/**
 * 根据项目pid获取项目的曲线展示数据，如果有时间，则返回对应时间的数据，如果没有时间就返回当天的数据
* @param params
 * @param pid
 * @returns {*}
 */
export function deviceChart(params,pid) {
    return request({
        url: '/assign/'+pid+'/chart',
        method: 'get',
        params
    })
}

/**
 * 用户的指定项目表格或者曲线的关注字段
 * @param data
 * @param pid
 * @returns {*}
 */
export function focusFields(data,pid) {
    return request({
        url: '/user/project/'+pid+'/focusFields',
        method: 'post',
        data
    })
}

/**
 * 获取最新一条数据
 * @param pid
 * @returns {*}
 */
export function dataLast(pid,params) {
    return request({
        url: '/assign/'+pid+'/last',
        method: 'get',
        params
    })
}

